import PageCurrent from '@/PageCurrent'
import PageBacklog from '@/PageBacklog'
import PageArchive from '@/PageArchive'
import PageDocs from '@/PageDocs'
import { createRouter, createWebHistory } from 'vue-router'

import CurrentIcon from '@/assets/icon-current.svg'
import PlanningIcon from '@/assets/icon-planning.svg'
import ClosedIcon from '@/assets/icon-closed.svg'
import DocsIcon from '@/assets/icon-docs.svg'

const pathSegments = window.location.pathname.split('/'),
  prefix = '/' + pathSegments[1]

let routes = [
  {
    path: prefix + '/',
    name: 'PageCurrent',
    component: PageCurrent,
    meta: { title: 'Текущие задачи', icon: CurrentIcon },
  },
  {
    path: prefix + '/planning',
    name: 'PageBacklog',
    component: PageBacklog,
    meta: { title: 'Планирование', icon: PlanningIcon },
  },
  {
    path: prefix + '/closed',
    name: 'PageArchive',
    component: PageArchive,
    meta: { title: 'Архив задач', icon: ClosedIcon },
  },
  {
    path: prefix + '/docs',
    name: 'PageDocs',
    component: PageDocs,
    meta: { title: 'Документы', icon: DocsIcon },
  },
]

let router = createRouter({
  history: createWebHistory(),
  linkActiveClass: 'menu__item--active',
  linkExactActiveClass: '',
  routes,
})

export default router
